export default __webpack_public_path__ + "static/app-data-deletion-alert-92825e9c33c591a0eeddd1854eb2491b.jpg";